import React, { ReactNode } from "react";
import type { IconComponent } from "../../types/ui";
interface EmptyStateProps {
  icon: IconComponent;
  title: string;
  description?: string;
  action?: ReactNode;
  compact?: boolean;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  compact
}: EmptyStateProps) {
  return <div className={`flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-200 bg-canvas/60 text-center ${compact ? 'px-4 py-6' : 'px-6 py-12'}`} data-id="element-755" data-mp="1sdadjbz0ojg8">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-mutedlight shadow-sm ring-1 ring-slate-200" data-id="element-756" data-mp="10mmeq6ktfq5q">
        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-757" data-mp="14npsmnjazc4b" />
      </span>
      <p className="mt-3 text-sm font-medium text-slate-700" data-id="element-758" data-mp="19grbt7qjlxtp">{title}</p>
      {description && <p className="mt-1 max-w-sm text-xs text-muted" data-id="element-759" data-mp="cycuh9393agp">{description}</p>}
      {action && <div className="mt-4" data-id="element-760" data-mp="gz6kq94611cr">{action}</div>}
    </div>;
}